const types = require('../../constants/actionTypes');

const amountChanged = ({ amount }) => ({
    type: types.GROWTH_AMOUNT_CHANGED,
    payload: { amount },
});

module.exports = amountChanged;
